import { Link } from "@tanstack/react-router";
import { FileQuestion } from "lucide-react";
import "../styles/pages/error-page.css";
import "../styles/components/action-button.css";

export default function NotFound() {
  return (
    <div className="container page-content">
      <div className="error-page">
        <FileQuestion size={56} className="error-page__icon" />
        <h1 className="error-page__error-code">404</h1>
        <h2 className="error-page__title">Page not found</h2>
        <p className="error-page__message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="action-button action-button--primary">
          Back to Directory
        </Link>
      </div>
    </div>
  );
}
